<template>
  <div>
    <!-- <CRow v-if="isAuthenticated === true">
      <CCol md="12">
        <CCard>
          <CCardHeader>
            Overview
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol lg="3" md="4">
                <CIcon name="cil-user" height="60"/>
                <CCallout color="info">
                  <small class="text-muted">Username</small><br>
                  <strong class="h4">{{user.username}}</strong>
                </CCallout>
              </CCol>
              <CCol lg="3" md="4">
                <CIcon name="icon-enterprise" height="60"/>
                <CCallout color="success">
                  <small class="text-muted">Workspaces</small><br>
                  <strong class="h4">2</strong>
                </CCallout>
              </CCol>
              <CCol lg="3" md="4">
                <CIcon name="icon-project" height="60"/>
                <CCallout color="warning">
                  <small class="text-muted">Projects</small><br>
                  <strong class="h4">3</strong>
                </CCallout>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow> -->
    <!-- <CRow v-else> -->
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <h4>CCTV Gateway</h4>            
            <!-- <div class="card-header-actions">
              <a 
                href="https://coreui.io/vue/docs/3.2/"
                class="card-header-action" 
                rel="noreferrer noopener" 
                target="_blank"
              >
                <small class="text-muted">docs</small>
              </a>
            </div> -->
          </CCardHeader>
          <CCardBody>
            <h5> &emsp; {{contents}} </h5>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import { axiosInstance } from '@/api'
// import MainChartExample from './charts/MainChartExample'
// import WidgetsDropdown from './widgets/WidgetsDropdown'
// import WidgetsBrand from './widgets/WidgetsBrand'

export default {
  name: 'Dashboard',
  components: {
    // MainChartExample,
    // WidgetsDropdown,
    // WidgetsBrand
  },
  data () {
    return {
      // tableItems: [
      //   {
      //     avatar: { url: 'img/avatars/1.jpg', status: 'success' },
      //     user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'USA', flag: 'cif-us' },
      //     usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Mastercard', icon: 'cib-cc-mastercard' },
      //     activity: '10 sec ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/2.jpg', status: 'danger' },
      //     user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
      //     country: { name: 'Brazil', flag: 'cif-br' },
      //     usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Visa', icon: 'cib-cc-visa' },
      //     activity: '5 minutes ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/3.jpg', status: 'warning' },
      //     user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'India', flag: 'cif-in' },
      //     usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Stripe', icon: 'cib-stripe' },
      //     activity: '1 hour ago'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/4.jpg', status: '' },
      //     user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'France', flag: 'cif-fr' },
      //     usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'PayPal', icon: 'cib-paypal' },
      //     activity: 'Last month'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/5.jpg', status: 'success' },
      //     user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'Spain', flag: 'cif-es' },
      //     usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Google Wallet', icon: 'cib-google-pay' },
      //     activity: 'Last week'
      //   },
      //   {
      //     avatar: { url: 'img/avatars/6.jpg', status: 'danger' },
      //     user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
      //     country: { name: 'Poland', flag: 'cif-pl' },
      //     usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
      //     payment: { name: 'Amex', icon: 'cib-cc-amex' },
      //     activity: 'Last week'
      //   }
      // ],
      // tableFields: [
      //   { key: 'avatar', label: '', _classes: 'text-center' },
      //   { key: 'user' },
      //   { key: 'country', _classes: 'text-center' },
      //   { key: 'usage' },
      //   { key: 'payment', label: 'Payment method', _classes: 'text-center' },
      //   { key: 'activity' },
      // ],
      // selected: 'Month',
      contents: 'ระบบจัดการ CCTV',
      projects: [],
      workspaces: []
    }
  },
  mounted() {
    // If the user is suspended, Fronend will not call APIs.
    // let i = 0
    // let interval = setInterval(() => {
    //   if (this.isSuspended !== undefined || i > 25) {
    //     clearInterval( interval )
    //     // console.log('Router Guard clear interval ')
    //     if(this.$store.state.user.isSuspended === true) {
    //       // console.log('Router Guard Reject')
    //     } else if(this.$store.state.user.isSuspended === false) {
    //       // console.log('Router Guard Accept')
    //       this.getProject()
    //       this.getWorkspace()
    //       this.getProjectTransfer()
    //     } else {
    //       // console.log('Router Guard Reject The pending user')
    //     }
    //   }
    //   // console.log('Router Guard Check #',i)
    //   i++
    // }, 200)
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    isAuthenticated () {
      return this.$store.state.isAuthenticated
    },
    isSuspended () {
      return this.$store.state.user.isSuspended
    }
  },
  methods: {
    // color (value) {
    //   let $color
    //   if (value <= 25) {
    //     $color = 'info'
    //   } else if (value > 25 && value <= 50) {
    //     $color = 'success'
    //   } else if (value > 50 && value <= 75) {
    //     $color = 'warning'
    //   } else if (value > 75 && value <= 100) {
    //     $color = 'danger'
    //   }
    //   return $color
    // },
    // getProjectTransfer() {
    //   axiosInstance({
    //     method: 'get',
    //     url: '/cluster/namespace_transfer',
    //   })
    //   .then(response => {
    //     if(response.status === 200) {
    //       if(response.data.namespaceTransfers.length > 0) {
    //         this.$store.commit("set", ['tasksCount', response.data.namespaceTransfers.length])
    //       }
    //     }
    //   })
    //   .catch(error => {
    //     console.log(error)
    //   })
    // },
  }
}
</script>

<style scoped lang="scss">
  .c-icon {
    fill: #4e696d;
  }
  // Set position: relative & adjust position to relate with Icon
  .c-callout {
    top: -65px;
    left: 76px;
  }
</style>